<template>
  <div>
    <seal v-if="refProvided"></seal>
    <div v-else>
      <login-seal></login-seal>
    </div>
  </div>
</template>

<script>
import Seal from '@/components/Seal/Seal'
import LoginSeal from '@/components/Seal/LoginSeal'

export default {
  name: 'SealView',
  components: {
    Seal,
    LoginSeal
  },
  computed: {
    refProvided () {
      return document.referrer || this.$route.query?.ref
    },
  },
}
</script>
